// extracted by mini-css-extract-plugin
export default {"content":"Profitability_content__Fayd6"};